import moment, { Moment } from 'moment'
import { PreOrderSettings } from '@ancon/wildcat-types'

import getCompanyOrderMaxDate from './getCompanyOrderMaxDate'

/**
 * Whether a company order can be placed for the day: from today until the
 * end of the company horizon. The backend doesn't check the horizon.
 */
export default function isCompanyOrderDateInRange(
  orderDate: string,
  preOrderSettings: PreOrderSettings | null | undefined,
  today: Moment = moment(),
) {
  const date = moment(orderDate)

  return (
    !date.isBefore(today, 'day') &&
    !date.isAfter(getCompanyOrderMaxDate(preOrderSettings, today), 'day')
  )
}
